/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiDELETE, apiGET, apiGETPaginated, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Returns all the existing lawyers according to the provided filters, with pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getLawyersPaginated(filters) {
    return await apiGETPaginated('/api/lawyers', filters);
}

/**
 * Returns all the existing lawyers without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getLawyers() {
    return await apiGET('/api/lawyers');
}

/**
 * Updates the provided lawyer with the information.
 *
 * @param lawyer
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editLawyer(lawyer) {
    return await apiPUT('/api/lawyer/' + lawyer.id, lawyer);
}

/**
 * Creates a new lawyer with the provided data.
 *
 * @param lawyer
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createLawyer(lawyer) {
    return await apiPOST('/api/lawyer', lawyer);
}

/**
 * Deletes the provided lawyer
 *
 * @param lawyer
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteLawyer(lawyer) {
    return await apiDELETE('/api/lawyer/' + lawyer.id);
}